import React, { Component } from 'react';

import ConfiguracionBasicaActiveDirectory from "./ConfiguracionBasicaActiveDirectory";
import ModoActiveDirectory from "./ModoActiveDirectory";

const DetalleConfiguracionActiveDirectory = (props) => {

    var isFirefox = typeof InstallTrigger !== 'undefined';
    const divStyleFireFox = {
        marginTop:'-15px'
      };

      const divStyle = {
        marginTop:'0px'
      };

    if (props.tipoConfiguracion == 2) {
        return (
            <div className="row">
                <div className="row row-radio">
                    <div className="left-separator-xs panel panel-view">
                        <div className="container-radio radio-margin panel-view-radio">
                            <input id="tipoConfiguracion4" type="radio" name="group12" checked={true} />
                            <label className="lbl-radio label-secondary panel-view-label level-auxiliary">
                                <i className="ti-microsoft-alt  panel-view-icon" />
                                <p style={isFirefox ? divStyleFireFox : divStyle } >Active Directory</p>
                                <span>Administra usuarios, perfiles y permisos contemplando el directorio de usuarios y grupos de Windows.</span>
                            </label>
                        </div>
                    </div>
                </div> 

                <div className="col-xs-12 left-separator-xs">
                    <ConfiguracionBasicaActiveDirectory
                        maxDiasInactividad={props.maxDiasInactividad}
                        minutosPermitidosInactividad={props.minutosPermitidosInactividad}
                        checkboxChangeState={props.checkboxChangeState}
                        maxDiasInactividadCheck={props.maxDiasInactividadCheck}
                        minutosPermitidosInactividadCheck={props.minutosPermitidosInactividadCheck}
                        textChangeState={props.textChangeState}/>
                </div>

                <div className="col-xs-12 left-separator-xs">
                    <ModoActiveDirectory
                        vincularGrupoWindows={props.vincularGrupoWindows}
                        altaAutomatica={props.altaAutomatica}
                        soloUsuarioLoggeado={props.soloUsuarioLoggeado}
                        solicitarContrasenia={props.solicitarContrasenia}
                        checkboxChangeState={props.checkboxChangeState}
                        radioButtonChange={props.radioButtonChange}
                        textChangeState={props.textChangeState}/>
                </div>

            </div> );
    } 

    else if (props.tipoConfiguracion == 1){
        return (
            <div className="row">
                <div className="row row-radio">
                    <div className="left-separator-xs panel panel-view">
                        <div className="container-radio radio-margin panel-view-radio">
                            <input id="tipoConfiguracion3" type="radio" name="group12" checked={false} />
                            <label className="lbl-radio label-secondary panel-view-label level-auxiliary" onClick={() => props.configurationTypeChange(props.tipoConfiguracion)} >
                                <i className="ti-microsoft-alt  panel-view-icon" />
                                <p style={isFirefox ? divStyleFireFox : divStyle} >Active Directory</p>
                                <span>Administra usuarios, perfiles y permisos contemplando el directorio de usuarios y grupos de Windows.</span>
                            </label>
                        </div>
                    </div>
                </div> 
            </div> );
    }
};

export default DetalleConfiguracionActiveDirectory;